const wowApp = require('angular').module('wowApp.common');

wowApp.directive('bwsDownloadApp', [
    'SettingsService',
    'AtmService',
    require('./download-app-button-directive')
]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/download-app-button/index.js
 **/